define('models/product_reseller_price',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'product-prices/' + this.id + '/' ) :
                ( App.Config.apiBase + 'product-prices/' );
        },

        defaults: function () {
            return {
                id: null,
                product: 0,
                cd_group: null,
                reseller_group: null,
                distributor_group: null,
                exchange_currency: 0,
                price: 0.0
            };
        }
    });
});
